import { render } from "./EditPaymentMethod.vue?vue&type=template&id=0eceb16c"
import script from "./EditPaymentMethod.vue?vue&type=script&lang=js"
export * from "./EditPaymentMethod.vue?vue&type=script&lang=js"
script.render = render

export default script